<template>
  <v-dialog v-model="isOpen" width="600px">
    <v-card>
      <v-toolbar elevation="0">
        <v-toolbar-title class="text--subtitle">
          <v-icon color="primary" style="padding-bottom: 2px">mdi-link</v-icon>
          {{ $t('message.pages.externalSourceVideo.addExternalVideo') }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon @click="handleCancelAddExternalSourceVideo">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text class="px-5 pt-0 pb-6">
        <b>{{
          $t(
            'message.pages.externalSourceVideo.description.paragraph1Sentence1'
          )
        }}</b
        >{{
          $t(
            'message.pages.externalSourceVideo.description.paragraph1Sentence2'
          )
        }}<br /><br />
        {{ $t('message.pages.externalSourceVideo.description.paragraph2') }}
      </v-card-text>
      <v-card-text class="pl-5 pr-8 pt-0 pb-4">
        <v-row>
          <v-col cols="7" class="pb-0 pt-0">
            <label>{{
              $t('message.pages.externalSourceVideo.labels.externalSource')
            }}</label>
            <v-select-legacy
              v-model="externalSourceOption"
              :items="externalSources"
              item-text="label"
              item-value="value"
              hide-details
              dense
              outlined
            >
            </v-select-legacy>
          </v-col>
          <v-col cols="12" class="pb-0">
            <label>
              {{
                $t('message.pages.externalSourceVideo.labels.sourceLink')
              }}</label
            >
            <v-text-field
              hide-details
              outlined
              dense
              autofocus
              v-model="externalSourceLink"
            >
            </v-text-field>
            <p class="tip" v-html="externalSourceLinkPlaceholder"></p>
          </v-col>
        </v-row>
        <v-row v-if="externalSourceOption === 's3'">
          <v-col cols="12" class="pb-0">
            <label>{{
              $t('message.pages.externalSourceVideo.labels.s3.akid')
            }}</label>
            <v-text-field v-model="s3AccessKeyID" outlined hide-details dense>
            </v-text-field>
            <p class="tip">
              {{ $t('message.eg') }}
              <code>{{
                $t('message.pages.externalSourceVideo.placeholders.s3.akid')
              }}</code>
            </p>
          </v-col>
          <v-col cols="12" class="pb-0">
            <label>{{
              $t('message.pages.externalSourceVideo.labels.s3.ski')
            }}</label>
            <v-text-field
              hide-details
              outlined
              dense
              v-model="s3SecretAccessKey"
            >
            </v-text-field>
            <p class="tip">
              {{ $t('message.eg') }}
              <code>{{
                $t('message.pages.externalSourceVideo.placeholders.s3.ski')
              }}</code>
            </p>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="px-8 pb-6 mt-6">
        <v-spacer></v-spacer>
        <v-btn
          text
          class="px-4"
          @click="handleCancelAddExternalSourceVideo"
          :disabled="loading"
        >
          <span class="mx-3">{{
            $t('message.pages.externalSourceVideo.cancel')
          }}</span>
        </v-btn>
        <v-btn
          color="primary"
          class="px-10"
          @click="handleConfirmAddExternalSourceVideo"
          :disabled="loading"
          :loading="loading"
        >
          <span class="mx-3">{{
            $t('message.pages.externalSourceVideo.confirm')
          }}</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import externalSourceVideoApi from '@/services/externalSourceVideoApi.js'
import i18n from '@/translations/lang.js'

export default {
  name: 'AddExternalSourceVideoModal',
  props: {
    open: {
      type: Boolean,
      required: true,
      default: false,
    },
    currentFolderId: {
      required: false,
      default: false,
    },
  },
  data: () => ({
    loading: false,
    externalSourceOption: 'youtube',
    externalSources: [
      {
        label: 'Youtube',
        value: 'youtube',
      },
      {
        label: 'S3',
        value: 's3',
      },
      {
        label: i18n.t('message.pages.externalSourceVideo.labels.simple'),
        value: 'url',
      },
    ],
    externalSourceLink: '',
    s3AccessKeyID: '',
    s3SecretAccessKey: '',
  }),
  computed: {
    externalSourceLinkPlaceholder() {
      const options = {
        youtube: 'https://youtu.be/[video_id]',
        s3: 'https://[bucket_name].s3.amazonaws.com/',
        url: 'https://[domain]/video.mp4',
      }
      return `${i18n.t('message.eg')} <code>${
        options[this.externalSourceOption]
      }</code>`
    },
    isOpen: {
      get() {
        return this.open
      },
      set(val) {
        if (!val) {
          this.handleCancelAddExternalSourceVideo()
        }
      },
    },
  },
  methods: {
    handleCancelAddExternalSourceVideo() {
      this.externalSourceLink = ''
      this.externalSourceOption = 'youtube'
      this.$emit('close')
    },
    async handleConfirmAddExternalSourceVideo() {
      this.loading = true
      const data = await externalSourceVideoApi.createExternalSourceVideo(
        this.externalSourceLink,
        this.externalSourceOption,
        this.currentFolderId
      )
      const videoFormat = {
        title: data.title,
        id: data.id,
        status: data.status,
        folder_id: data.folder_id,
        updated_at: data.updated_at,
        video_external_source_id: data.video_external_source_id,
      }
      this.$root.$emit('addVideoVideosPage', videoFormat)
      this.$router.push({ name: 'VideoPage', params: { id: data.id } })
      this.handleCancelAddExternalSourceVideo()
      this.loading = false
    },
  },
}
</script>

<style scoped>
>>> .tip {
  margin: 4px 0px 0px 4px;
}
</style>
